import formatDate from 'src/filters/formatDate';
import formatTime from 'src/filters/formatTime';
import formatTimeWithSec from 'src/filters/formatTimeWithSec';

const formatDateTime = (datetime, withSec = false) => `${formatDate(datetime)} `
  + `${withSec ? formatTimeWithSec(datetime) : formatTime(datetime)}`;

export default formatDateTime;
